// A small status label in the IPD semantic palette: square corners, no dot —
// the plain tag the HMIS lists use. Tones: good, warn, bad, info, neutral (the
// five sessionView.statusChip and the board's bed states use).

import React from "react";
import { Box } from "@mui/material";

import { IPD_COLORS } from "../../ipd/utils";

export const TONES = {
  good: IPD_COLORS.success,
  warn: IPD_COLORS.warning,
  bad: IPD_COLORS.error,
  info: IPD_COLORS.info,
  neutral: { bg: IPD_COLORS.panelHeaderBg, text: IPD_COLORS.textSecondary, border: IPD_COLORS.border },
};

export default function ToneChip({ tone = "neutral", label, sx = {} }) {
  const colors = TONES[tone] || TONES.neutral;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 0.75,
        py: 0.25,
        borderRadius: "4px",
        fontSize: 11.5,
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: "nowrap",
        bgcolor: colors.bg,
        color: colors.text,
        ...sx,
      }}
    >
      {label}
    </Box>
  );
}
